/** biome-ignore-all lint/style/useNamingConvention: allow snake case */
import {useEffect, useState} from 'react';
import {apiClient} from '~/api/api-client';

interface NiftHookProps {
  email: string;
  referral_code?: string;
}

interface NiftHookReturn {
  nift_gift_available: boolean;
  nift_affiliate_url: string;
}

export const useNift = ({email, referral_code}: NiftHookProps) => {
  const [niftGiftAvailable, setNiftGiftAvailable] = useState(false);
  const [niftAffiliateUrl, setNiftAffiliateUrl] = useState('');
  const isNiftFeatureSwitchEnabled = evite.features.isEnabled('nift', false);

  const isNiftGiftAvailable = async () => {
    const resp = await apiClient.post(
      '/ajax/nift/nift-gift-available/',
      {email, ...(referral_code && {referral_code})},
      {headers: {'Content-Type': 'application/json'}}
    );

    if (resp.ok) {
      const body: NiftHookReturn = await resp.json();
      setNiftGiftAvailable(body.nift_gift_available);
      setNiftAffiliateUrl(body.nift_affiliate_url);
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    if (isNiftFeatureSwitchEnabled) {
      isNiftGiftAvailable();
    }
  }, [email, referral_code, isNiftFeatureSwitchEnabled]);

  return {niftGiftAvailable, niftAffiliateUrl};
};
